<template>
  <div v-if="loading" class="loader menu dinline-block vtop fs14 pl35" >
    <div class="loader-inner ball-pulse">
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
  <div v-else class="menu dinline-block vtop fs14 pl35">
    <list-xnews :id="id" :pid="pid" :list="list" :total="total" :page="page"
                :per-page="perPage" :get-data="getData" :clear-list="clearList"
                v-if="$params.column[this.pid]['children'][this.id]['params']['template'] == 'xnews'"/>
    <list-nev :id="id" :pid="pid" :list="list" :total="total" :page="page"
              :per-page="perPage" :get-data="getData"
              v-else-if="$params.column[this.pid]['children'][this.id]['params']['template'] == 'nev'"/>
    <list-star :id="id" :pid="pid" :list="list" :total="total" :page="page"
               :per-page="perPage" :get-data="getData"
               v-else-if="$params.column[this.pid]['children'][this.id]['params']['template'] == 'star'"/>
    <list-notice :id="id" :pid="pid" :list="list" :total="total" :page="page"
                 :per-page="perPage" :get-data="getData"
                 v-else-if="$params.column[this.pid]['children'][this.id]['params']['template'] == 'notice'"/>
    <list-file :id="id" :pid="pid" :list="list" :total="total" :page="page"
                :per-page="perPage" :get-data="getData"
                v-else-if="$params.column[this.pid]['children'][this.id]['params']['template'] == 'file'"/>
    <list-teacher :id="id" :pid="pid" :list="list" :total="total" :page="page"
               :per-page="perPage" :get-data="getData"
               v-else-if="$params.column[this.pid]['children'][this.id]['params']['template'] == 'teacher'"/>
    <list-media :id="id" :pid="pid" :list="list" :total="total" :page="page"
                :per-page="perPage" :get-data="getData"
                v-else/>
  </div>

</template>

<script>
import ListMedia from "../../components/un_index/ListMedia";
import ListNev from "../../components/un_index/ListNev";
import ListNotice from "../../components/un_index/ListNotice";
import ListStar from "../../components/un_index/ListStar";
import ListXnews from "../../components/un_index/ListXnews";
import ListFile from "../../components/un_index/ListFile";
import ListTeacher from "../../components/un_index/ListTeacher";
export default {
  name: "List",
  components:{
    ListMedia,
    ListNev,
    ListNotice,
    ListStar,
    ListXnews,
    ListFile,
    ListTeacher,
  },
  data(){
    return {
      id:'',
      pid:'',
      perPage:9,
      page:1,
      list:[],
      msg:'加载中……',
      total:0,
      loading:false
    }
  },
  updated() {
  },
  created() {
    this.id = this.$route.query.id
    this.pid = this.$route.query.pid
    this.loading = true
    this.getData()
  },
  methods:{
    clearList(){
    },
    getData(page){
      this.page = page;
      var getParam = {}
      var id = this.$params.column[this.pid]['children'][this.id]['params']['id']
      getParam['category_id'] = id
      getParam['perPage'] = this.perPage
      getParam['page'] = this.page
      this.$request.get('article/list',getParam,response => {
        if(response.status == 200 && response.data.data.data.length > 0){
          let res = response.data.data.data
          this.list = res
          this.total = response.data.data.total
        }else{
          this.list = []
          this.total = 0
          this.msg = '无数据';
        }
        this.loading = false;
      },error => {
        console.log(error)
      })
    },
  },
  watch:{
    $route:{
      deep:true,
      handler:function($n,$o){
        this.id = $n.query.id
        this.pid = $n.query.pid
        if ($n.query.pid !== $o.query.pid || $n.query.id !== $o.query.id) {
          this.loading = true
          this.getData()
        }
        this.list = [];
        this.page = 1;
      }
    },
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/evn/List.vue